// 二维码展示薄封装
// 用于 CareBot 老人/家属邀请链接，固定容错级别 M 与白色边距，避免微信扫码识别率问题

import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeDisplayProps {
  value: string;
  size?: number;
  className?: string;
  ariaLabel?: string;
}

export const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({
  value,
  size = 192,
  className,
  ariaLabel = '二维码',
}) => {
  if (!value) return null;

  return (
    <div
      className={className}
      role="img"
      aria-label={ariaLabel}
      style={{ display: 'inline-block', padding: 12, background: '#ffffff', borderRadius: 12 }}
    >
      <QRCodeSVG
        value={value}
        size={size}
        level="M"
        bgColor="#ffffff"
        fgColor="#0f172a"
        includeMargin={false}
      />
    </div>
  );
};

export default QRCodeDisplay;
